import { render, staticRenderFns } from "./org-pro-plan.vue?vue&type=template&id=60d75f0e&scoped=true&"
import script from "./org-pro-plan.vue?vue&type=script&lang=js&"
export * from "./org-pro-plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d75f0e",
  null
  
)

export default component.exports